import {
  FlexProps,
  Flex,
  Heading,
  Icon,
  Box,
  SimpleGrid,
  HStack,
  Link as ChakraLink,
  Text,
} from '@chakra-ui/react';
import { RiEyeLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../../../../../../hooks/auth';
import { IDetailedBookingUser } from '../../../../../../../../../services/Bookings/ShowBookingsService';

interface IBookingDetailsUserInfoProps extends FlexProps {
  user: IDetailedBookingUser;
}

const BookingDetailsUserInfo = ({
  user,
  ...rest
}: IBookingDetailsUserInfoProps): JSX.Element => {
  const { assignment: authenticatedAssignment } = useAuth();
  const featureGroupKey = user.userAssignments[0]?.featureGroup.key;

  const getLinkTo = ():
    | { pathname: string; state: { guestId: string } }
    | { pathname: string; state: { lodgerId: string } }
    | { pathname: string; state: { memberId: string } } => {
    if (featureGroupKey.includes('GUEST')) {
      return {
        pathname: '/guests/details' as const,
        state: { guestId: user.id },
      };
    }

    if (featureGroupKey.includes('LODGER')) {
      return {
        pathname: '/lodgers/details' as const,
        state: { lodgerId: user.id },
      };
    }

    return {
      pathname: '/members/details' as const,
      state: { memberId: user.id },
    };
  };

  const getUserTypeLabel = (): string => {
    if (featureGroupKey.includes('GUEST')) return 'Convidado';
    if (featureGroupKey.includes('LODGER')) return 'Hóspede';
    return 'Membro';
  };

  const linkTo = getLinkTo();
  const userTypeLabel = getUserTypeLabel();

  return (
    <Flex direction="column" px="8" {...rest}>
      <Heading size="md" fontWeight="normal">
        {userTypeLabel}
      </Heading>

      <Box mt="4" px="4">
        <SimpleGrid columns={[1, 1, 1, 1, 4]} spacing="4" w="100%">
          <Text fontSize="lg" fontWeight="bold">
            {user.name}
          </Text>

          <HStack>
            <Text fontSize="sm">Telefone:</Text>
            <Text color="gray.500" fontSize="sm">
              {user.phone}
            </Text>
          </HStack>

          <HStack>
            <Text fontSize="sm">E-mail:</Text>
            <Text color="gray.500" fontSize="sm">
              {user.email}
            </Text>
          </HStack>

          {authenticatedAssignment?.featureGroup.features.some((feature) =>
            ['USER_FULL_ACCESS', 'USER_READ_ACCESS'].includes(feature.key),
          ) && (
            <ChakraLink ml="auto" as={Link} to={linkTo}>
              <HStack>
                <Icon color="blue.300" as={RiEyeLine} fontSize="20" />
                <Text color="blue.300">Detalhes</Text>
              </HStack>
            </ChakraLink>
          )}
        </SimpleGrid>
      </Box>
    </Flex>
  );
};

export default BookingDetailsUserInfo;
